// extracted by mini-css-extract-plugin
module.exports = {"filtersSortBy":"styles_filtersSortBy__3w9Gg"};